/* eslint-disable max-len */
import React from 'react';
import ReactStars from 'react-rating-stars-component';
import { I18n } from 'react-redux-i18n';

class purchaseFeedback extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      feedBack: {
        websiteReviewScore: 0,
        feedbackText: '',
      },
      messageErro: '',
    };

    this.initialState = this.state;
  }

  setFeedback = async (feedbackData) => {
    const { feedBack } = this.state;

    await this.setState({
      feedBack: {
        ...feedBack,
        ...feedbackData,
      },
    });
  }

  closeFeedback = () => {
    this.props.closePurchaseFeedback();
  }

  sendFeedback = async () => {
    const { feedBack } = this.state;

    if (!feedBack.feedbackText) await this.setState({ messageErro: I18n.t('purchaseFeedbackOpinionTextWarning') });
    else if (!feedBack.websiteReviewScore) await this.setState({ messageErro: I18n.t('purchaseFeedbackRatingWarning') });
    else await this.setState({ messageErro: '' });

    if (!this.state.messageErro) {
      this.props.closePurchaseFeedback(feedBack);
    }
  }

  render() {
    const { feedBack, messageErro } = this.state;
    const { feedbackText } = feedBack;

    return (
      <div
        className="modal"
        role="presentation"
        id="product-feedback"
        style={{ display: 'block', zIndex: '10' }}
      >
        <div className="purchase-feedback-modal-content purchase-modal-content-product-feedback">
          <div className="modal-body">
            <div className="column body-modal-text" style={{ padding: '40px 0 20px 0' }}>
              <div className="_reason-cancel-order">
                <p className="product-feedback-label" style={{ textAlign: 'center' }}>
                  {I18n.t('purchaseFeedbackRating')}
                </p>
                <div style={{ paddingBottom: '15px', display: 'flex', justifyContent: 'center' }}>
                  <ReactStars
                    count={5}
                    size={48}
                    activeColor="#ffd700"
                    onChange={score => this.setFeedback({ websiteReviewScore: score })}
                  />
                </div>
                <div className="product-feedback-row">
                  <p className="product-feedback-label" style={{ textAlign: 'center' }}>
                    {`${I18n.t('feedback')} ?`}
                  </p>
                  <textarea
                    rows="5"
                    type="text"
                    className="product-feedback-textarea"
                    maxLength={500}
                    value={feedbackText}
                    onChange={event => this.setFeedback({ feedbackText: event.target.value })}
                  />
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                  <button
                    type="button"
                    className="cancel-button-product-feedback"
                    onClick={this.closeFeedback}
                  >
                    {I18n.t('cancelFeedBackButton')}
                  </button>
                  <button
                    type="button"
                    className="button-product-feedback"
                    style={{ width: '110px' }}
                    onClick={this.sendFeedback}
                  >
                    {I18n.t('submit')}
                  </button>
                </div>
                {!!messageErro && (
                  <p className="purchase-feedback-label">
                    {messageErro}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default purchaseFeedback;
